import React, { useContext, useEffect } from "react";
import { Form as FormAntd,message } from "antd";
import { Layer } from "../../../../component/layer/layer";
import { FormBasic } from "./from_basic";
import { Button } from "../../../../component/button";
import { FormStore } from "../../store/promotion/form_store";
import { formAction } from "../../action/promotion/form_action";
import { useBoolean } from "ahooks";

interface IForm {
    children?: any;
    action: any;
    close: (hasUpdate?: boolean) => void;
    id?: string;
    subId: string;
    method?: string;
    audit: boolean;
    item;
}
export function Form({ close, method, id, subId, item, audit }: IForm) {
    const [form] = FormAntd.useForm();

    const { state, dispatch } = useContext(FormStore);
    const [loading, loadFunc] = useBoolean(false)
    const action = formAction;

    useEffect(() => {

        action.init({ state: state, dispatch, id, form, method });

        return () => {

        }
    }, []);

    const title = () => {
        if ("Create" === method) {
            return "新增时段促销";
        }
        else if ("Edit" === method) {
            return "编辑时段促销";
        }
        else {
            return "预览时段促销";
        }
    }

    return (
        <FormAntd form={form}>
            <Layer layerWith={3} >
                <Layer.Title onClick={() => close()}>{title()}</Layer.Title>
                <Layer.Body>
                    <FormBasic disabled={!("Create" == method || "Edit" == method)} title={title()} isEdit={"Edit" == method} updateFormField={(field, value = '') => {
                        //为表单某个字段设置数据
                        form.setFieldsValue({
                            [field]: value,
                        });
                        //验证表单的某个字段
                        form.validateFields([field]);
                    }} />
                </Layer.Body>
                <Layer.Foot borderStyle={title() == '预览时段促销' ? { border: 'none' } : {}}>
                    {
                        ("Create" == method || "Edit" == method) && audit && (
                            <>   <Button type="primary" color="Red" onClick={async () => {
                                const s = await form.validateFields();
                                if(loading){
                                    message.loading('正在提交数据')
                                    return false
                                }
                                let r = false;
                                if ("Create" == method) {
                                    loadFunc.setTrue()
                                    r = await action.addSubmit({ state, status: 1 });
                                    loadFunc.setFalse()
                                } else {
                                    loadFunc.setTrue()
                                    r = await action.updSubmit({ state, status: 1 }, subId);
                                    loadFunc.setFalse()
                                }
                                if (r) {
                                    action.clearTableList({ dispatch });

                                    close(true);
                                }
                            }}>
                                保存
                            </Button>
                                <Button type="primary" color="Yellow" style={{ marginLeft: "1.25rem" }} onClick={async () => {
                                    action.clearTableList({ dispatch });
                                    close(true);
                                    // action.reset({dispatch})
                                }}>
                                    返回
                                </Button>

                            </>
                        )
                    }



                </Layer.Foot>

            </Layer>
        </FormAntd>
    )
}